import React, { FC, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import moment from 'moment/moment';

import { DAY_FIRST_CALENDAR_FORMAT } from '../../lib/constants/date-time.constants';
import { PredefinedMilisecondsTypeEnum } from '../../lib/enums';
import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { getDefaultSelectableTradingPLanFromState } from '../../lib/store/crm/helpers';
import { CRMCall } from '../../lib/store/crm/types';
import { calculateTimeRemaining, formatTimeRemainingHours } from '../../lib/util/DateTimeHelpers';
import { isCallStatusReady } from '../../lib/util/error-handling/StatusByCallHelpers';

import IconClock from '../../assets/img/clock.svg';

import styles from './TournamentEndTimerLite.module.scss';

type Props = ReduxProps & {};

const TournamentEndTimerLite: FC<Props> = (props: Props): JSX.Element => {
  const { tradingPlan, isTradingPlanReady } = props;
  const { plans_accounts_deactivation: endDate } = tradingPlan;
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [hasNoRemainingTime, setHasNoRemainingTime] = useState(true); // we will display nothing until the calculation is complete that's why default is TRUE

  useEffect(() => {
    if (!isTradingPlanReady) {
      return;
    }
    calculateTimeRemaining(endDate, setHasNoRemainingTime, setDays, setHours, setMinutes, setSeconds); // Initial calculation
    const intervalId = setInterval(() => {
      calculateTimeRemaining(endDate, setHasNoRemainingTime, setDays, setHours, setMinutes, setSeconds);
    }, PredefinedMilisecondsTypeEnum.oneSecond);

    return () => clearInterval(intervalId); // eslint-disable-line consistent-return
  }, [endDate, isTradingPlanReady]);

  if (hasNoRemainingTime) {
    return <></>;
  }

  const displayEndDate = moment(endDate).format(DAY_FIRST_CALENDAR_FORMAT);
  const displayRemainingTime = formatTimeRemainingHours(days, hours, minutes, seconds);
  const isMoreThan1Day = days >= 1;

  return (
    <div className={styles.wrapper}>
      <div className={styles.iconAndLabel}>
        <img alt="" className={styles.clock} src={IconClock} />
        <span className={styles.date}>{lang.commonMyPositionTournamentEndsAs(isMoreThan1Day ? displayEndDate : '')}</span>
        {!isMoreThan1Day && <span className={styles.timer}>{displayRemainingTime}</span>}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  tradingPlan: getDefaultSelectableTradingPLanFromState(state.crm),
  isTradingPlanReady: isCallStatusReady(CRMCall.searchTradingPlans, state.crm.statusByCall),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(TournamentEndTimerLite);
